<template>
  <v-dialog v-model="showDialog" max-width="750px">
    <v-card>
      <v-card-title>
        <h3>{{ $vuetify.t('$vuetify.AdminCategories.deleteHeader') }}</h3>
      </v-card-title>
      <v-card-text>
        <p>
          {{ $vuetify.t('$vuetify.AdminCategories.deleteText', category.name) }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="deleteCategory" class="error">
          {{ $vuetify.t('$vuetify.AdminCategories.deleteConfirm') }}
        </v-btn>
        <v-btn @click="showDialog = false">
          {{ $vuetify.t('$vuetify.AdminCategories.deleteCancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '../../api'

export default {
  name: 'CategoryDeleteDialog',
  props: {
    show: Boolean,
    category: Object
  },
  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        if (value === false) {
          this.$emit('handleClose', value)
        }
      }
    }
  },
  methods: {
    deleteCategory: function () {
      api.category.remove(this.category.id)
        .then(res => {
          if (res.status < 400) {
            this.$emit('handleSuccess', true)
          } else {
            this.$emit('handleError', false)
          }
        })
    }
  }
}
</script>
